/**
 * Build absolute paths under ``/api/v1`` from ``VITE_API_BASE_URL`` (``/api`` or full origin).
 */
export function apiV1Url(path: string): string {
  const raw = (import.meta.env.VITE_API_BASE_URL || '/api').trim()
  const origin = raw.replace(/\/api\/?$/, '')
  const base = origin ? `${origin}/api/v1` : '/api/v1'
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${base}${suffix}`
}

/**
 * Match erp-api ``legacy_api_v1_rewrite_path`` — unversioned ``/api/*`` → ``/api/v1/*``,
 * except ``/api/uploads/*`` (served outside the v1 router).
 */
export function legacyApiV1RewritePath(path: string): string {
  if (!path.startsWith('/api/')) {
    return path
  }
  const rest = path.slice('/api/'.length)
  if (rest === 'v1' || rest.startsWith('v1/')) {
    return path
  }
  if (rest === 'uploads' || rest.startsWith('uploads/')) {
    return path
  }
  return `/api/v1/${rest}`
}

/** Rewrite axios/fetch request paths to ``/api/v1/*`` when needed. */
export function rewriteRequestApiPath(url: string): string {
  if (!url) {
    return url
  }
  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url)
      const nextPath = legacyApiV1RewritePath(parsed.pathname)
      if (nextPath !== parsed.pathname) {
        parsed.pathname = nextPath
        return parsed.toString()
      }
    } catch {
      return url
    }
    return url
  }
  return legacyApiV1RewritePath(url)
}
